import FindStore from '../../images/FindStore.png';
function FindAStore() {
    return (
        <div style={{ marginLeft: '2.5px', marginRight: '20px', marginTop: '20px' }}>
            <img src={FindStore} style={{ width: '100%', height: '' }} alt="" />
        </div>
    );
}
export default FindAStore;